import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['frame']

  open() {
    this.element.showModal()
  }

  close() {
    this.element.close()
    this.frameTarget.innerHTML = ''
  }
}
